export default __webpack_public_path__ + "static/media/step2-4.65711cd6.jpg";